// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_di-6";
export var emphasizeQuantity = "_di-3";
export var flatBottomCorners = "_di-5";
export var productImage = "_di-0";
export var quantityContainer = "_di-2";
export var tooltip = "_di-1";
export var wrapAndEllipsesOverflow = "_di-4";